import React from 'react';

const SectionDivider = () => (
    <div className="row">
        <div className="column">
            <div className="section-divider" />
        </div>
    </div>
);

export default SectionDivider;
